import React, { PureComponent } from 'react';
import CheckIcon from 'mdi-react/CheckIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import PropTypes from 'prop-types';
import classNames from 'classnames';


export default class CheckBox extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ]).isRequired,
    label: PropTypes.string,
    defaultChecked: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    color: PropTypes.string,
  };

  static defaultProps = {
    label: '',
    defaultChecked: false,
    disabled: false,
    className: '',
    color: '',
  };

  componentDidMount() {
    const { onChange, defaultChecked } = this.props;
    onChange(defaultChecked);
  }

  render() {
    const {
      disabled, className, name, value, onChange, label, color,
    } = this.props;
    const CheckboxClass = classNames({
      'il-checkbox-btn': true,
      disabled,
    });
    // console.log(label);
    // let formattedLabel = label;
    // if (label && label.includes('<strong>')) {
    //   formattedLabel = "<span dangerouslySetInnerHTML={{__html: label}} />";
    // }

    return (
      <label
        className={`${CheckboxClass} ${className ? ` il-checkbox-btn--${className}` : ''}`}
        htmlFor={name}
      >
        <input
          className="il-checkbox-btn__checkbox"
          type="checkbox"
          id={name?.split(' ')?.join('')}
          name={name}
          onChange={onChange}
          checked={value}
          disabled={disabled}
        />
        <span
          className="il-checkbox-btn__checkbox-custom"
          style={color ? { background: color, borderColor: color } : {}}
        >
          <CheckIcon />
        </span>
        {className === 'button'
          ? (
            <span className="il-checkbox-btn__label-svg">
              <CheckIcon className="il-checkbox-btn__label-check" />
              <CloseIcon className="il-checkbox-btn__label-uncheck" />
            </span>
          ) : ''}
        {label && label.includes('<strong>') ? (
          <span style={{marginLeft: '30px'}} dangerouslySetInnerHTML={{__html: label}} />
        ) : (
          <span style={{marginLeft: '30px'}}>
            {label}
          </span>
        )}
      </label>
    );
  }
}
